export default __webpack_public_path__ + "static/media/JAS0150.34I-43218_-25841_0.b7f65808.jpg";